var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-offers-grid inner-body-block"},_vm._l((_vm.data.offers),function(offer){return _c('offer',{key:offer.id,staticClass:"no-border",attrs:{"item":offer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }